export default {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
};



// WEBPACK FOOTER //
// ./src/views/users/constants/genders.js